import React from "react";
import {Col, Row} from "reactstrap";
import {useTranslation} from "react-i18next";

const BodyModalMessageSetupComponent = () => {
    const {t} = useTranslation();
    return (
        <React.Fragment>
            <Row>
                <Col>
                    <div className="mb-3">
                        <p>{t("log.complete_setup")}</p>
                        <ul>
                            <li><a href="/economic?setup=invoice" target="_blank" rel="noreferrer">{t("log.setup_invoices")}</a></li>
                            <li><a href="/economic?setup=common" target="_blank" rel="noreferrer">{t("log.setup_general")}</a></li>
                        </ul>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default BodyModalMessageSetupComponent
